"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAY_FORMATS = exports.DATE_FORMATS = undefined;
exports.addThousandsSeparator = addThousandsSeparator;
var _momentTimezone = require("moment-timezone");
var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var thousandsRegex = /(\d{3})(?=\d)/g;
function addThousandsSeparator(amount) {
  var decimalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var decimalSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
  var thousandsSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ",";
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    var negativeSign = amount < 0 ? "-" : "";
    var i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    var j = i.length > 3 ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousandsSeparator : '') + i.substr(j).replace(thousandsRegex, "$1" + thousandsSeparator) + (decimalCount ? decimalSeparator + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.error(e);
  }
}
;
var DATE_FORMATS = exports.DATE_FORMATS = {
  es: 'MMMM D',
  en: 'MMMM Do',
  de: 'D/MMMM'
};
var DAY_FORMATS = exports.DAY_FORMATS = {
  es: 'D',
  en: 'Do',
  de: 'D'
};